export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AML-Prüfung"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geben Sie eine Adresse ein und wählen Sie eine Blockchain — wir führen ein schnelles Screening durch."])}
}